<div class="aspect-auto flex h-screen w-screen">
    <div class="left-section items-center">
        <div class="left-section-content">
            <div class="header text-4xl">
                "{{'Reset Password' | textCase}}"
            </div>
            <div class="my-2 text-base mt-4">
                "{{'Please choose your new password' | textCase}}"
            </div>
            <div class="my-3">
                <form [formGroup]="resetPassword" (ngSubmit)="onSubmit()">
                    <div class="p-fluid">
                        <div class="flex flex-col p-fluid gap-2">
                            <div class="input-group">
                                <label for="newPassword">{{"Enter New Password" | textCase}}</label>
                                <div class="input-password">
                                    <p-password formControlName="newPassword" [toggleMask]="true"
                                        promptLabel="{{'Choose a password' | textCase}}"
                                        weakLabel="{{'Too simple' | textCase}}"
                                        mediumLabel="{{'Average complexity' | textCase}}"
                                        strongLabel="{{'Complex password' | textCase}}" />
                                </div>
                            </div>
                            <div class="input-group">
                                <label for="confirmPassword">{{"Confirm New Password" | textCase}}</label>
                                <div class="input-password">
                                    <p-password formControlName="confirmPassword" toggleMask="true" autofocuss />
                                </div>
                            </div>
                        </div>
                        <div class="mt-4">
                            <app-button variant="filled" severity="primary" label="{{'Reset Password' | textCase}}"
                                [disabled]="!resetPassword" (clicked)="onSubmit()" />
                        </div>

                        <div class="flex items-center gap-4 justify-center w-[18.75rem] text-slate-600  mt-5 text-justify cursor-pointer hover:text-orange-500"
                            [routerLink]="'/login'">
                            <i class="pi pi-arrow-left"></i>
                            <span>{{"Back to Login" | textCase}}</span>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="right-section">
        <img class="login-image" [src]="'images/login-page.png' | assetUrl" alt="{{'login-image' | textCase}}">
    </div>
</div>
